import React from 'react';
import ImageGallery from 'react-image-gallery';

export default function ImageModal({ setShowImageModal, imageArray }) {
	console.log('IMAGES: ', imageArray);

	/** */
	const baseURL = 'https://cwc-product-images-s3-bucket.s3.amazonaws.com/';

	const images = imageArray.map((img) => {
		return {
			original: baseURL + img.Key,
			thumbnail: baseURL + img.Key,
		};
	});

	return (
		<div className="bg-black bg-opacity-40 h-screen flex items-center justify-center overflow-hidden w-full z-[10] fixed top-0 left-0">
			<div className="absolute left-[100px] top-[100px]">
				<svg
					onClick={() => setShowImageModal(false)}
					width="24"
					height="24"
					fill="none"
					className="text-white rounded-full bg-red-500"
					viewBox="0 0 24 24"
				>
					<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.25 6.75L6.75 17.25"></path>
					<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6.75 6.75L17.25 17.25"></path>
				</svg>
			</div>
			<div className="flex items-center justify-center">
				<ImageGallery showBullets={false} showPlayButton={false} items={images} />
			</div>
		</div>
	);
}
